import { Component, OnInit, ViewChild, ChangeDetectorRef, ViewEncapsulation, ChangeDetectionStrategy, AfterContentInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, NgForm, Validators } from '@angular/forms';
import { ActivatedRoute, Router} from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { DialogHelper, ExceptionHelper } from './../../../../helper';
import { PMStatus } from '../../../../model';

import * as $ from 'jquery';
import { saveAs } from 'file-saver';
import {PreventiveMaintenanceAssignFormService} from '../preventive-maintenance-assign-form';
import { TeamSummaryService } from '../../user/team-summary.service';
import { PreventiveMaintenanceDetailService, PreventiveMaintenanceEquipmentSummaryService } from '../preventive-maintenance-detail';
import { PreventiveMaintenanceEditService } from './preventive-maintenance-edit.service';
import { JobDetailService } from '../../job/job-detail';

import { DatePipe } from '@angular/common';
import { DateTimeAdapter, OWL_DATE_TIME_FORMATS, OWL_DATE_TIME_LOCALE } from 'ng-pick-datetime';
import { OWL_datetime_formats } from './../../owl_datetime_formats';
import { Store } from '@ngxs/store';
import { UpdatePMDetail, ClearPMDetail } from '../actions/pm-detail.action';
import * as moment from 'moment';

@Component({
  selector: 'app-preventive-maintenance-edit',
  templateUrl: './preventive-maintenance-edit.component.html',
  styleUrls: [
      './preventive-maintenance-edit.component.css',
  ],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
        {provide: OWL_DATE_TIME_FORMATS, useValue: OWL_datetime_formats},
    ],
})
export class PreventiveMaintenanceEditComponent implements OnInit {

    @ViewChild('dangerModal') dangerModal: any;

    first = true;
    second = false;
    haveEq: boolean;

    teams = [];
    dropdownSettings = {};

    technicians = [];
    dropdownSettingsTechnician = {};

    pmEquipments: any[];
    jobEquipments: any[];
    pmEquipmentDataTable: any;
    jobEquipmentDataTable: any;
    eqINpm = {};
    pmequipmentListModel = [];

    pmuserAssignModels = [];

    pmId = '';
    pm: any;
    pmStatus = PMStatus;

    redirect = true;
    isDownloading = false;

    editPMForm: FormGroup;

    createTime: Date ;
    customer: string = "";
    customerShortName: string = "";
    jobNumber: string = "";
    pmServiceBeginDate: Date;
    pmServiceFinishDate: Date;
    schedule: string = "";
    remarks: string = "";
    teamIds: Array<string> = [];
    technicianIds: Array<string> = [];
    tentativeBeginDate: Date ;
    tentativeFinishDate: Date ;


  constructor(
    private assignFormService: PreventiveMaintenanceAssignFormService,
    private datePipe: DatePipe,
    private router: Router,
    private route: ActivatedRoute,
    private translateService: TranslateService,
    private dialog: DialogHelper,
    private exception: ExceptionHelper,
    private pmEditService: PreventiveMaintenanceEditService,
    private pmDetailService: PreventiveMaintenanceDetailService,
    private pmEquipmentSummaryService: PreventiveMaintenanceEquipmentSummaryService,
    private jobDetailService: JobDetailService,
    private teamSummaryService: TeamSummaryService,
    private formBuilder: FormBuilder,
    private chRef: ChangeDetectorRef,
    private store: Store
    ) {
    this.route.params.subscribe(params => { this.pmId = params['id']; });
    translateService.setDefaultLang('en-us');
}

    createEditPMForm() {
        this.editPMForm = this.formBuilder.group({

            createTime: new FormControl({value: '', disabled: true }, [
                Validators.required,
            ]),
            customerShortName: new FormControl({value: '', disabled: true }, [
                Validators.required,
                Validators.maxLength(100)
            ]),
            customer: new FormControl({value: '', disabled: true }, [
                Validators.required,
                Validators.maxLength(100)
            ]),
            jobNumber: new FormControl({value: '', disabled: true }, [
                Validators.required,
                Validators.maxLength(100)
            ]),
            tentativeBeginDate: new FormControl([
            ]),
            tentativeFinishDate: new FormControl([
            ]),
            pmServiceBeginDate: new FormControl([
            ]),
            pmServiceFinishDate: new FormControl([
            ]),
            dates: new FormControl('', [
                Validators.required,
            ]),
            teamIds: new FormControl([ [],
                Validators.required,
            ]),
            technicianIds: new FormControl([ [],
            ]),
            status: new FormControl([
                Validators.required,
            ]),
            schedule: new FormControl([
                Validators.maxLength(1000)
            ]),
            remarks: new FormControl([
                Validators.maxLength(1000)
            ]),

        });
    }

  editPM(editPMForm) {

    this.selectTechnician();

      this.pmEditService.edit(this.pmId, editPMForm.controls, this.pmequipmentListModel, this.pmuserAssignModels).subscribe(
        data  => {
          if (data) {
            this.dialog.showModal('showSucModalBtn');
          }
        },
        error => {
          this.exception.showError(error, 'showDanModalBtn');
          this.redirect = false;
        });

  }
  goToAssignForm(pmId, eqDetailId) {
    this.store.dispatch(new UpdatePMDetail(this.editPMForm.getRawValue())).subscribe(res => {
      this.router.navigate(['/home/preventive-maintenance/assignForm'], {
        queryParams: { pmId, eqDetailId }
      });
    });

  }

  ngOnInit() {

    this.dropdownSettings = {
      singleSelection: false,
      text: "Select Team",
      enableCheckAll: false,
      enableSearchFilter: true,
      labelKey: "name"
    };

    this.dropdownSettingsTechnician = {
      singleSelection: false,
      text: 'Select Technician',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      enableSearchFilter: true,
      labelKey: "title"
    };

    this.createEditPMForm();

    this.teamSummaryService.getSummary().subscribe((data: any) => {

        this.teams = data;
        $('div.c-btn').attr('id', 'multi-select');
      },
      error => {
        this.exception.showError(error, 'showDanModalBtn');
        this.redirect = true;
      });

    this.getPMdetails();

  }

  getPMdetails() {
    this.pmDetailService.getDetail(this.pmId).subscribe( (data) => {

      this.pm = data;

      this.editPMForm.setValue({
        createTime: this.pm.createTime ,
        customerShortName: this.pm.customerShortName ,
        customer: this.pm.customer ,
        jobNumber: this.pm.jobNumber ,
        tentativeBeginDate: (this.pm.tentativeBeginDate != null ?
          moment(this.pm.tentativeBeginDate, 'YYYY-MM-DD HH:mm:ss').toDate() : null ) ,
        tentativeFinishDate: (this.pm.tentativeFinishDate != null ?
           moment( this.pm.tentativeFinishDate, 'YYYY-MM-DD HH:mm:ss').toDate() : null) ,
        pmServiceBeginDate: (this.pm.pmServiceBeginDate != null ?
           moment( this.pm.pmServiceBeginDate, 'YYYY-MM-DD HH:mm:ss').toDate() : null) ,
        pmServiceFinishDate: (this.pm.pmServiceFinishDate != null ?
           moment( this.pm.pmServiceFinishDate, 'YYYY-MM-DD HH:mm:ss').toDate() : null) ,
        teamIds: ( this.pm.teamListModel != null ? this.pm.teamListModel : [] ) ,
        technicianIds: ( this.pm.userArrayModels != null ? this.pm.userArrayModels : [] ) ,
        schedule: this.pm.schedule ,
        remarks: this.pm.remarks ,
        status: this.pm.status,
        dates: 'NA'

      });
      this.onClose(null);

      this.tentativeBeginDate = (this.pm.tentativeBeginDate != null ? new Date( this.pm.tentativeBeginDate ) : null );
      this.tentativeFinishDate = (this.pm.tentativeFinishDate != null ? new Date( this.pm.tentativeFinishDate ) : null);
      this.pmServiceBeginDate = (this.pm.pmServiceBeginDate != null ? new Date( this.pm.pmServiceBeginDate ) : null);
      this.pmServiceFinishDate = (this.pm.pmServiceFinishDate != null ? new Date( this.pm.pmServiceFinishDate ) : null);
      this.createTime = new Date( this.pm.createTime) ;
      this.createTime.setHours(0, 0, 0, 0);

      this.pmuserAssignModels = [];
      if (this.pm.userArrayModels) {
        for (const ori of this.pm.userArrayModels) {
          const tempModel = {
            userId: ori.id,
            isActive: 0
          };
          this.pmuserAssignModels.push(tempModel);
        }
      }

      if (this.pm.teamListModel) {
        this.getTeamMemberSummary();
      }
      this.getPMEquipmentSummary();

    },
    error => {
      $('.card').hide();
      this.exception.showError(error, 'showDanModalBtn');
      this.redirect = true;

    }, () => {
      this.store.selectOnce(state => state.pmDetail.pmDetail).subscribe(res => {
        if (res !== null) {
          this.editPMForm.setValue(res);
          this.store.dispatch(new ClearPMDetail());
        }
      });
    });
  }

  getPMEquipmentSummary() {
    this.pmEquipmentSummaryService.getSummary(this.pmId).subscribe( (data) => {

      if ($.fn.dataTable.isDataTable('#PMequipmentDataTables')) { $('#PMequipmentDataTables').DataTable().destroy(); }

      this.pmEquipments = data.pmequipmentListModel;

      this.haveEq = (this.pmEquipments.length === 0 ? false : true);

      this.chRef.detectChanges();

      const table: any = $('#PMequipmentDataTables');
      this.pmEquipmentDataTable = table.DataTable();

      this.getJobEquipmentSummary();

    },
    error => {
      $('.card').hide();
      this.exception.showError(error, 'showDanModalBtn');
      this.redirect = true;
    });
  }

  getJobEquipmentSummary() {
    this.jobDetailService.getEquipmentList(this.pm.jobNumber).subscribe( (data) => {

      if ($.fn.dataTable.isDataTable('#jobEquipmentDataTables')) { $('#jobEquipmentDataTables').DataTable().destroy(); }

      this.jobEquipments = data.equipmentListModel;

      this.pmequipmentListModel = [];

      for (const j of this.jobEquipments) {
        this.eqINpm[j.equipmentId] = false;

        for (const pm of this.pmEquipments) {
          if (j.equipmentId === pm.equipmentId) {
            this.eqINpm[j.equipmentId] = true;

            const pmequipmentModel = {
              equipmentDetailId: pm.equipmentDetailId,
              isActive: pm.isActive,
              // formIdsToStatus: null //
            };
            this.pmequipmentListModel.push(pmequipmentModel);
          }
        }

      }

      this.chRef.detectChanges();

      const table: any = $('#jobEquipmentDataTables');
      this.jobEquipmentDataTable = table.DataTable({
        "ordering": false,
      });

    },
    error => {
      $('.card').hide();
      this.exception.showError(error, 'showDanModalBtn');
      this.redirect = true;
    });
  }

  getTeamMemberSummary() {
    const teamIds = [];
    for (const team of this.editPMForm.controls.teamIds.value) {
      teamIds.push(team.id);
    }
    this.teamSummaryService.getTechnicianSummary(teamIds)
      .subscribe((data: any) => {
        this.technicians = data;
        $('div.c-btn').attr('id', 'multi-select');
      }, err => {
        this.exception.showError(err, 'showDanModalBtn');
        this.redirect = true;
      });
  }

  onTeamSelect(item: any) {
    this.getTeamMemberSummary();
  }

  onTeamDeselect(item: any) {
    // clear technicians input
    this.editPMForm.controls['technicianIds'].setValue([]);
    if (this.editPMForm.value.teamIds.length === 0) {
      // if no team is selected, clear technicians options
      this.technicians = [];
    } else {
      // else re-get technician list
      this.getTeamMemberSummary();
    }
  }

  selectTechnician() {
    if (this.editPMForm.controls.technicianIds.value) {
      for (const technician of this.editPMForm.controls.technicianIds.value) {
        const tempModel = {
          userId: technician.id,
          isActive: 1
        };
        this.pmuserAssignModels.push(tempModel);
      }
    }
  }

  selectAll(event): void {
    this.jobEquipments.forEach(equipment => {
      if (event.target.checked) {
        this.eqINpm[equipment.equipmentId] = true;
        this.haveEq = true;
      } else {
        this.eqINpm = {};
        this.haveEq = false;
      }
    });

    }

  selected() {

    this.pmequipmentListModel = [];

    let newList = [];
    for (const j of this.jobEquipments) {
      let exist = false;
      for (const pm of this.pmEquipments) {
        if (j.equipmentId === pm.equipmentId) { // original pm equipment list exist
          exist = true;

          if (this.eqINpm[j.equipmentId] === true) { // after edit still exist
            const pmequipmentModel = {
              equipmentDetailId: j.equipmentDetailId,
              equipmentId: j.equipmentId,
              isActive: 1,
              // formIdsToStatus: null //

            };
            this.pmequipmentListModel.push(pmequipmentModel);
            newList.push(j);
          }

          else { // after edit, removed
            const pmequipmentModel = {
              equipmentDetailId: j.equipmentDetailId,
              equipmentId: j.equipmentId,
              isActive: 0,
              // formIdsToStatus: null //
            };
            this.pmequipmentListModel.push(pmequipmentModel);
          }

        }

      }

      if (exist === false) { // original pm equipment list NOT exist
        if (this.eqINpm[j.equipmentId] === true) { // after edit, added
          const pmequipmentModel = {
            equipmentDetailId: j.equipmentDetailId,
            equipmentId: j.equipmentId,
            isActive: 1,
            // formIdsToStatus: null //
          };
          this.pmequipmentListModel.push(pmequipmentModel);
          newList.push(j);
        }

      }

    }

    // if ($.fn.dataTable.isDataTable('#PMequipmentDataTables')) { $('#PMequipmentDataTables').DataTable().destroy(); }
    // this.pmEquipments = newList;
    // this.chRef.detectChanges();
    // const table: any = $('#PMequipmentDataTables');
    // this.pmEquipmentDataTable = table.DataTable();
    this.pmEditService.assignEquipment(this.pmId, this.pmequipmentListModel).subscribe(res => {
      // this.chRef.detectChanges();
      this.getPMEquipmentSummary();
      this.back();

    }, error => {
      this.exception.showError(error, 'showDanModalBtn');
      this.redirect = false;
    });
  }

  downloadForm(formId, isSpecial, pmId, eqDetailId) {

    this.isDownloading = true;
    this.assignFormService.getForm(formId, isSpecial, pmId, eqDetailId ).subscribe(data => {
      const blob = new Blob([data.file], { type: 'application/pdf' });
      saveAs(blob, data.fileName);
      this.isDownloading = false;
      this.chRef.detectChanges();
    }, err => {
      this.isDownloading = false;
      this.exception.showError(err, 'showDanModalBtn');
      this.redirect = false;
    });
  }

  back() {
    this.first = true;
    this.second = false;
  }

  editEquipmentList() {
    this.first = false;
    this.second = true;
  }

  checkboxChange() {
    let eqCounter = 0;

    for (const eq in this.eqINpm) {
      if (this.eqINpm[eq] === true) {
        eqCounter++;
      }
    }

    if (eqCounter === 0) {
      this.haveEq = false;
    }
    else {
      this.haveEq = true;
    }
  }

  dateTimeChange(ele: any) {

    if (ele.input.id === 'tentativeBeginDate') {
      this.editPMForm.controls['status'].setValue(PMStatus.arranging);

      this.editPMForm.controls['pmServiceBeginDate'].setValue(null);
      this.editPMForm.controls['pmServiceFinishDate'].setValue(null);

      this.tentativeBeginDate = this.editPMForm.controls['tentativeBeginDate'].value;
    }
    else if (ele.input.id === 'tentativeFinishDate') {
      this.editPMForm.controls['status'].setValue(PMStatus.arranging);

      this.editPMForm.controls['pmServiceBeginDate'].setValue(null);
      this.editPMForm.controls['pmServiceFinishDate'].setValue(null);
    }
    else if (ele.input.id === 'pmServiceBeginDate') {
      this.editPMForm.controls['status'].setValue(PMStatus.confirmed);

      this.editPMForm.controls['tentativeBeginDate'].setValue(null);
      this.editPMForm.controls['tentativeFinishDate'].setValue(null);

      this.pmServiceBeginDate = this.editPMForm.controls['pmServiceBeginDate'].value;
    }
    else if (ele.input.id === 'pmServiceFinishDate') {
      this.editPMForm.controls['status'].setValue(PMStatus.confirmed);

      this.editPMForm.controls['tentativeBeginDate'].setValue(null);
      this.editPMForm.controls['tentativeFinishDate'].setValue(null);
    }


    if ( this.editPMForm.controls['pmServiceBeginDate'].value == null && this.editPMForm.controls['tentativeBeginDate'].value == null ) {
      this.editPMForm.controls['dates'].setErrors({'required': true});
    }
    else {
      this.editPMForm.controls['dates'].setErrors(null);
    }

  }

  onClose(items: any) {
    if (this.editPMForm.value.teamIds.length === 0) {
      this.editPMForm.controls['teamIds'].setErrors({'required': true});
    }
  }

  textareaInputRemarks() {

    const length = this.editPMForm.controls['remarks'].value.length;
    if ( length > 1000 ) {
      this.editPMForm.controls['remarks'].setErrors({'maxlength': {'actualLength': length, 'requiredLength': 1000} } );
    }
    else {
      this.editPMForm.controls['remarks'].setErrors(null);
    }
  }

  textareaInputSchedule() {
    const length = this.editPMForm.controls['schedule'].value.length;
    if ( length > 1000 ) {
      this.editPMForm.controls['schedule'].setErrors({'maxlength': {'actualLength': length, 'requiredLength': 1000} } );
    } else {
      this.editPMForm.controls['schedule'].setErrors(null);
    }
  }

  closeSuccessModel() {
    this.router.navigate(['/home/preventive-maintenance/detail/' + this.pmId]);
  }

  errorClose() {
    if (this.redirect) {
      this.router.navigate(['/home/preventive-maintenance']);
    }
    else {
      this.dangerModal.hide();
    }

  }



}



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/views/home/preventive-maintenance/preventive-maintenance-edit/preventive-maintenance-edit.component.ts